import { apiSlice } from "./apiSlice";

export const ncrLogSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get all NCR Log list
        getNCRLogList: builder.query({
            query: (params) => ({
                url: `NCRLog`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllNCRLog"],
        }),

        // Export all data (without pagination) in Excel File
        getExportNCRLogList: builder.query({
            query: (params) => ({
                url: `NCRLog`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

        // Get grouped category (open vs close) graph
        getNCRCategorySummary: builder.query({
            query: (params) => ({
                url: `NCRLog/summary/category-ncr-type`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllNCRLog"],
        }),

        // Get ageing analysis graph
        getNCRAgeingAnalysis: builder.query({
            query: (projectId) => ({
                url: `NCRLog/summary/ageing/${projectId}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllNCRLog"],
        }),

        // Get ncr log status count (closed / open)
        getNCRStatusCount: builder.query({
            query: (projectId) => ({
                url: `NCRLog/summary/${projectId}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllNCRLog"],
        }),

        // Create new ncr log
        createNCRLog: builder.mutation({
            query: ({ body }) => ({
                url: `NCRLog`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllNCRLog"],
        }),

        // Update ncr log
        updateNCRLog: builder.mutation({
            query: ({ body }) => ({
                url: `NCRLog`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["AllNCRLog"],
        }),

        getNcrKpiMetrics: builder.query({
            query: ({ projectId }) => ({
                url: "/NCRLog/kpi/metrics",
                method: "GET",
                params: { projectId },
            }),
        }),

        // Get all NCR Log list (Ageing Analysis of Open Items)
        getNCRLogListAgeingAnalysis: builder.query({
            query: ({ projectId, ...params }) => ({
                url: `NCRLog/summary/ageingdetails/${projectId}`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllNCRLog"],
        }),
    })
})

export const { useGetNCRLogListQuery, useLazyGetNCRLogListQuery, useGetNCRCategorySummaryQuery, useGetNCRAgeingAnalysisQuery,
    useGetNCRStatusCountQuery, useCreateNCRLogMutation, useUpdateNCRLogMutation, useGetNcrKpiMetricsQuery,
    useLazyGetNCRStatusCountQuery, useLazyGetNCRLogListAgeingAnalysisQuery, useLazyGetExportNCRLogListQuery } = ncrLogSlice;
